import { IApplicationState } from '../../types/redux';

export function getOtherBanks(state: IApplicationState) {
  return state.specialPromosBlocks.banks;
}
